import { window } from '../../../../globals';
import { useReleaseGroupLimit as useFetchReleaseGroupLimit } from '../../../../hooks/api';

/**
 * Hook to fetch and calculate the release group limit status.
 */
export const useReleaseGroupLimit = () => {
  const { data: value, isLoading } = useFetchReleaseGroupLimit(window?.user?.organizationId ?? 0);

  const isReleaseGroupsUnlimited = value?.unlimited === true;
  const isOverReleaseGroupLimit = !isReleaseGroupsUnlimited &&
    !!value?.usage &&
    value?.usage > value?.max;
  const isAtReleaseGroupLimit = !isReleaseGroupsUnlimited &&
    value?.usage === value?.max;

  return {
    value,
    isLoading,
    isAtReleaseGroupLimit,
    isOverReleaseGroupLimit,
    isReleaseGroupsUnlimited,
  };
};
